import React from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { isCardExpired } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import DeleteCardPopup from './DeleteCardPopup';
import { DiskBadgeWrapper } from '../styles';
import { CARD_TO_SUBSCRIPTION } from '../utils';

const CardPaymentMethod = (props) => {
    const { dcSourceExpired } = usePageMessages();
    const isExpired = isCardExpired(props.card);

    const getTitle = (name, description) => {
        if (description) {
            return (
                <>
                    <Text>{name}</Text>
                    <br />
                    <Text size="secondary" color="secondary">
                        {description}
                    </Text>
                </>
            );
        } else {
            return <Text color={isExpired ? 'lightGray' : null}>{name}</Text>;
        }
    };

    const onPanelClick = () => {
        if (props.onAddNewClick) {
            props.onAddNewClick();
        } else if (isExpired) {
            props.popupRef.current?.open(<DeleteCardPopup popupRef={props.popupRef} selectedCard={props.card} />);
        } else {
            props.openClick(props.card, CARD_TO_SUBSCRIPTION);
        }
    };

    return (
        <Panel onClick={onPanelClick} negativeMargin isHoverable>
            <PanelFrame>
                <DiskBadgeWrapper>
                    <DiskBadge
                        iconName={props.icon ? props.icon : null}
                        src={props.src ? props.src : null}
                        variant={props.diskVariant ? props.diskVariant : 'secondary'}
                        withoutRadius={props.withoutRadius}
                        isDisabled={isExpired}
                    />
                </DiskBadgeWrapper>
                <PanelContent>{getTitle(props.name, props.description)}</PanelContent>
                <PanelRightBlock>{isExpired ? <Badge variant="tertiary" caption={dcSourceExpired} /> : null}</PanelRightBlock>
            </PanelFrame>
        </Panel>
    );
};

export default CardPaymentMethod;
